import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { tap ,catchError, filter, finalize, switchMap, take } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { UiEventsService } from '../../shared/change_pwd.service'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  isReauth = false;
  tokenBehaviorSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  constructor(private auth: AuthService,  private uiEvents: UiEventsService) {

  }

  // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
  //   const token = this.auth.getToken();
  //   if (token && !req.url.includes('/assets')) {
  //     return next.handle(this.addToken(req, token)).pipe(catchError(err => {
  //       if (err instanceof HttpErrorResponse) {
  //         return this.onError(err, req, next);
  //       }
  //     }));
  //   } else if (!token) {
  //     if (!req.url.includes('/login')) {
  //       this.auth.signOut();
  //     }
  //   }
  //   return next.handle(req).pipe(catchError(err => {
  //     if (err instanceof HttpErrorResponse) {
  //       return this.onError(err, req, next);
  //     }
  //   }));
  // }
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const excludedUrls = ['/sign-in', '/assets', '/refresh'];
    const shouldSkip = excludedUrls.some(url => req.url.includes(url));
  
    if (shouldSkip) {
      return next.handle(req);
    }
  
    const token = this.auth.getToken();
  
    const handle = (request: HttpRequest<any>) =>
      next.handle(request).pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            // console.log('[HTTP Response]', event.body?.status);
            if (event.body?.status === 2) {
              this.uiEvents.requestOpenChangePasswordDialog();
            }
          }
        }),
        catchError(err => {
          if (err instanceof HttpErrorResponse) {
            return this.onError(err, req, next);
          }
          return throwError(err);
        })
      );
  
    if (token) {
      return handle(this.addToken(req, token));
    } else {
      this.auth.signOut();
      return handle(req);
    }
  }
  private onError(error: HttpErrorResponse, req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    if (error.status === 401) {
      if (!this.isReauth) {
        this.isReauth = true;
        this.tokenBehaviorSubject.next(null)
        const refreshToken = this.auth.getRefreshToken();
        return this.auth.refreshToken(refreshToken).pipe(
          switchMap((res) => {
            if(res.status == 1){
              this.auth.saveToken(
                res.token,
                res.refresh_token
              );
              this.tokenBehaviorSubject.next(res.token)
              return next.handle(this.addToken(req, res.token));
            }else{
              this.auth.signOut();
              return throwError('');
            }
          }),
          finalize(() => {
            this.isReauth = false;
          })
        );
      } else {
        return this.tokenBehaviorSubject
          .pipe(
            filter(token => token != null),
            take(1),
            switchMap(token => {
              return next.handle(this.addToken(req, token));
            })
          );
      }
    } else if (error.status === 403) {
      this.auth.signOut();
      return throwError(error);
    }
    return throwError(error);
  }
  private addToken(req: HttpRequest<any>, token: string) {
    return req.clone({
      setHeaders: {
        "Authorization": 'Bearer ' + token
      }
    });
  }
}
